<template>
  <!-- 审核信息展示区域 -->
  <a-modal
    :title="title"
    :visible="blackVisible"
    width="600px"
    @cancel="handleClose"
  >
    <!-- <a-spin :spinning="confirmLoading"> -->
    <div class="messageDetail">
      <p class="messageDetail-p">
        <strong>发送失败原因：</strong>
        <span> {{ modal.errInfo }} </span>
      </p>
      <p>
        <strong>任务标题：</strong>
        <span> {{ modal.mgTkInfos[0].title }} </span>
      </p>
      <p>
        <strong>客户姓名：</strong>
        <span> {{ modal.paramFormats[0].userName }} </span>
      </p>
      <p>
        <strong>&nbsp;&nbsp;&nbsp;手机号：</strong>
        <span> {{ modal.account }} </span>
      </p>
      <div class="sendContent">
        <strong>发送内容：</strong>
        <div class="sendSpan">
          <span> {{ modal.content }} </span>
        </div>
        <div class="triangle"></div>
      </div>
    </div>
    <!-- </a-spin> -->
    <template slot="footer">
      <a-button type="primary" @click="handleOk"> 确定 </a-button>
    </template>
  </a-modal>
</template>
<script>
// import { getAction, postAction } from '@/api/manage';
// import customRender from '@/utils/customRender.js';
export default {
  name: 'MessageTaskModal',
  data() {
    return {
      title: '查看详情',
      form: this.$form.createForm(this),
      model: {
        errInfo: '',
        mgTkInfos: [],
        paramFormats: [],
        account: '',
        content: '',
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      blackVisible: false,
    };
  },
  methods: {
    add(record) {
      console.log(record);
      this.blackVisible = true;
      this.modal = record;
    },
    // 确定
    handleOk() {
      this.blackVisible = false;
    },
    handleClose() {
      this.blackVisible = false;
    },
  },
};
</script>
<style scoped lang="less">
/deep/ .ant-modal-body {
  height: 500px;
  overflow: auto;
}
.messageDetail {
  font-weight: 500;
  color: #000;
  p {
    padding: 10px 50px;
  }
  strong {
    font-weight: 500;
  }
}
.messageDetail-p {
  color: red;
}
.sendContent {
  font-weight: 500;
  color: #000;
  padding: 10px 50px;
  strong {
    font-weight: 500;
  }
}
.sendSpan {
  width: 292px;
  min-height: 98px;
  position: relative;
  left: 80px;
  top: -20px;
  border-radius: 10px;
  background: #eef0f3;
  padding: 10px 15px;
  span {
    min-height: 98px;
  }
}
.triangle {
  width: 0;
  height: 0;
  border: 18px solid;
  border-color: transparent transparent transparent #eef0f3;
  position: relative;
  left: 80px;
  top: -40px;
}
</style>
